<template>
  <div class="px-3 min-vh-100 d-flex flex-column">
    <section class="mb-1">
      <img
        :src="useAsset('img/credit-line/cards_coins_sparkle_straight.svg')"
        alt="sparkle coins card"
      />
      <h1 class="mt-3 p-0">
        {{ t("JOINT_LOAN_LIMIT_INCREASE_BANNER.TITLE") }}
      </h1>
      <p class="p-0">{{ t("JOINT_LOAN_LIMIT_INCREASE_BANNER.SUBTITLE") }}</p>
      <div>
        <span>{{ amount }}</span>
      </div>
    </section>

    <BulletList :items="items" class="mt-5" gap="32px" />

    <Button
      @click="redirectLimitIncreaseSign"
      type="primary"
      class="mt-5 mb-auto"
    >
      {{ t("JOINT_LOAN_LIMIT_INCREASE_BANNER.BUTTON") }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import BulletList from "@/apps/credit-line/components/BulletList.vue";
import { useRouter } from "vue-router";
import Button from "@/apps/credit-line/components/Button.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { computed } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import GoogleAnalyticsEventsHelper from "@/shared-helpers/google-analytics-events.helper";

const { t } = useI18n();
const router = useRouter();

defineProps<{
  amount?: string;
}>();

const items = computed(() => [
  { text: t("JOINT_LOAN_LIMIT_INCREASE_BANNER.ITEM1") },
  {
    text: t("JOINT_LOAN_LIMIT_INCREASE_BANNER.ITEM2"),
  },
  {
    text: t("JOINT_LOAN_LIMIT_INCREASE_BANNER.ITEM3"),
  },
]);

const redirectLimitIncreaseSign = () => {
  logAnalyticsEvent(
    GoogleAnalyticsEventsHelper.CreditLine
      .JointLoanLineLimitIncreaseUnlockCardClicked,
    "Super Pacman First Limit Increase"
  );
  router.replace({ name: "LimitIncreaseSignView" });
};
</script>

<style lang="scss" scoped>
h1 {
  color: var(--Typography-Text-2-ICON, #595a5a);
  font-feature-settings: "liga" off, "clig" off;

  /* SUPER HEADING */
  font-family: Inter, serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

p {
  color: var(--Typography-Text-3-sub, #8b8b8b);
  font-feature-settings: "liga" off, "clig" off;
  padding: 0;
  margin: 0;
  /* Section heading - Bottons */
  font-family: Inter, serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}

span {
  color: var(--Primary-Main-green, #007c3b);
  font-family: Inter, serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.18px;
}
</style>
